import React from "react";

export const getPaymentsApprovalAggregateTone = (approval) => {
  if (!approval) return "neutral";
  const statuses = (approval?.approvers || [])
    .map((a) => String(a?.status || "").toLowerCase())
    .filter(Boolean);
  if (statuses.length === 0) return "pending";
  if (statuses.some((s) => s === "rejected" || s === "отклонен")) return "rejected";
  if (
    statuses.every((s) => s === "approved" || s === "согласован") &&
    statuses.length > 0
  ) {
    return "approved";
  }
  return "pending";
};

export const getApprovalStatusText = (approval) => {
  const tone = getPaymentsApprovalAggregateTone(approval);
  if (tone === "rejected") return "Отклонено";
  if (tone === "approved") return "Согласовано";
  return "На рассмотрении";
};

export const getApproverStatusLabelRu = (status) => {
  const s = String(status || "").toLowerCase();
  if (s === "approved" || s === "согласован") return "Согласован";
  if (s === "rejected" || s === "отклонен") return "Отклонён";
  return "На рассмотрении";
};

export const getApproverRowStatusTone = (status) => {
  const s = String(status || "").toLowerCase();
  if (s === "approved" || s === "согласован") return "approved";
  if (s === "rejected" || s === "отклонен") return "rejected";
  return "pending";
};

export const ApprovalStatusBadge = ({ approval, approvalStatusText }) => {
  const approversList =
    approval && Array.isArray(approval.approvers) && approval.approvers.length > 0
      ? approval.approvers
      : null;
  const ariaApprovers =
    approversList &&
    approversList
      .map((a) => {
        const name =
          [a?.user?.surname, a?.user?.name].filter(Boolean).join(" ").trim() ||
          (a?.user_id != null ? `ID ${a.user_id}` : "Согласующий");
        return `${name}: ${getApproverStatusLabelRu(a?.status)}`;
      })
      .join("; ");
  const tone = approval ? getPaymentsApprovalAggregateTone(approval) : "neutral";
  const toneClass =
    tone === "approved"
      ? "pp-approval-badge--approved"
      : tone === "rejected"
        ? "pp-approval-badge--rejected"
        : tone === "pending"
          ? "pp-approval-badge--pending"
          : "pp-approval-badge--neutral";

  return (
    <span
      className={
        approversList
          ? "pp-approval-badge-tooltip-host pp-approval-badge-tooltip-host--rich"
          : "pp-approval-badge-tooltip-host"
      }
    >
      <span
        className={`pp-approval-badge ${toneClass}`}
        {...(ariaApprovers
          ? { "aria-label": `Согласующие: ${ariaApprovers}` }
          : {})}
      >
        {approvalStatusText}
      </span>
      {approversList && (
        <div className="pp-approval-tooltip-panel" role="tooltip">
          <ul className="pp-approval-tooltip-list">
            {approversList.map((a) => {
              const name =
                [a?.user?.surname, a?.user?.name].filter(Boolean).join(" ").trim() ||
                (a?.user_id != null ? `ID ${a.user_id}` : "Согласующий");
              const rowTone = getApproverRowStatusTone(a?.status);
              return (
                <li
                  key={a.id ?? `${a.user_id}-${a.approval_id ?? ""}`}
                  className="pp-approval-tooltip-row"
                >
                  <span className="pp-approval-tooltip-name">{name}</span>
                  <span className="pp-approval-tooltip-sep"> — </span>
                  <span
                    className={`pp-approval-tooltip-status pp-approval-tooltip-status--${rowTone}`}
                  >
                    {getApproverStatusLabelRu(a?.status)}
                  </span>
                </li>
              );
            })}
          </ul>
        </div>
      )}
    </span>
  );
};
